<template>
  <div>
    <el-card shadow="hover">
      <div style="padding: 10px" v-loading="loading">
        <div v-loading="queryIng">
          <el-empty v-if="!!errorMsg" :description="errorMsg" :image-size="100">
            <el-button @click="getDetail" size="small"> 重新加载 </el-button>
          </el-empty>
          <div v-else-if="editModel" class="config-box">
            <div class="config-wrap">
              <div class="config-left">
                <height-view :offsetSize="150">
                  <warehouse-goods-select
                    :storeGuid="editModel.storeGuid"
                    :params="goodsSelectParams"
                    :multipleable="true"
                    :showMenu="false"
                    placeholder="添加商品"
                  >
                    <template slot="info-append" slot-scope="scope">
                      <div style="color: #919191">
                        <span> 零售单价: </span>
                        <template v-if="scope.info.retailPrice > 0">
                          <span
                            v-if="scope.info.retailPrice > 0"
                            style="color: #333333; font-weight: bolder"
                          >
                            {{ scope.info.retailPrice }}
                          </span>
                          <span> 元/件 </span>
                        </template>
                        <template v-else>
                          <span style="color: #f56c6c"> 未设置 </span>
                        </template>
                      </div>
                      <div style="color: #919191; margin-bottom: 10px">
                        <span> 当前库存: </span>
                        <template>
                          <span style="color: #333333; font-weight: bolder">
                            {{ scope.info.stockCount }}
                          </span>
                          <span>
                            {{
                              (scope.info.skuInfo && scope.info.skuInfo.goodsUnit) || "件"
                            }}
                          </span>
                        </template>
                      </div>
                      <template v-if="getItemBySkuGuid(scope.info.skuGuid)">
                        <el-input-number
                          type="number"
                          v-model="getItemBySkuGuid(scope.info.skuGuid).goodsCount"
                          @change="handleItemChange"
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :max="scope.info.stockCount"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          @click="removeClick(getItemBySkuGuid(scope.info.skuGuid))"
                        >
                          移出清单
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          type="primary"
                          size="small"
                          @click="handleAddSelectList([scope.info])"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </template>
                  </warehouse-goods-select>
                  <el-table
                    stripe
                    v-if="goodsItemList && goodsItemList.length > 0"
                    :data="goodsItemList"
                    :size="$xUISize"
                    style="width: 100%; margin-top: 10px"
                  >
                    <el-table-column label="商品信息" min-width="320px">
                      <template slot-scope="scope">
                        <div style="margin-right: 10px">
                          <goods-sku-info :skuInfo="scope.row.skuInfo">
                            <template slot="info-append">
                              <div style="color: #919191">
                                <span> 当前库存: </span>
                                <template>
                                  <span style="color: #333333; font-weight: bolder">
                                    {{
                                      (scope.row.goodsInfo &&
                                        scope.row.goodsInfo.stockCount) ||
                                      0
                                    }}
                                  </span>
                                  <span>
                                    {{
                                      (scope.row.skuInfo &&
                                        scope.row.skuInfo.goodsUnit) ||
                                      "件"
                                    }}
                                  </span>
                                </template>
                              </div>
                            </template>
                          </goods-sku-info>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="单价" width="100px">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          class="borderless-input"
                          v-model="scope.row.goodsPrice"
                          placeholder="单价"
                        >
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="数量" width="200px">
                      <template slot-scope="scope">
                        <el-input-number
                          type="number"
                          style="width: 160px"
                          v-model="scope.row.goodsCount"
                          @change="handleItemChange"
                          :max="scope.row.goodsInfo.stockCount"
                          :min="1"
                        >
                        </el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120px">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          type="danger"
                          @click="removeClick(scope.row)"
                        >
                          移出
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="color: #999999; font-size: 14px; margin-top: 20px">
                    * 请添加商品到清单
                  </div>
                </height-view>
              </div>
              <div class="config-right">
                <height-view :offsetSize="150">
                  <el-form
                    ref="form"
                    :size="$xUISize"
                    :model="editModel"
                    :rules="editRules"
                    @submit.native.prevent
                    label-width="auto"
                    label-position="top"
                  >
                    <el-form-item>
                      <el-button
                        type="primary"
                        :disabled="editModel.orderReceivedAmount <= 0"
                        @submit.native.prevent
                        @click="submitClick"
                      >
                        创建订单
                      </el-button>
                    </el-form-item>
                    <el-form-item label="取货密码" prop="unlockNumber" key="unlockNumber">
                      <el-input
                        type="text"
                        class="borderless-input border_bottom"
                        style="font-size: 20px"
                        v-model="editModel.unlockNumber"
                        placeholder="请输入四位取货密码"
                      >
                      </el-input>
                    </el-form-item>
                    <el-form-item label="订单备注" prop="userRemark" key="userRemark">
                      <el-input
                        type="text"
                        class="borderless-input border_bottom"
                        style="font-size: 20px"
                        v-model="editModel.userRemark"
                        placeholder="请输入订单备注"
                      >
                      </el-input>
                    </el-form-item>
                    <el-form-item
                      label="订单金额"
                      prop="orderReceivedAmount"
                      key="orderReceivedAmount"
                    >
                      <el-input
                        type="number"
                        class="borderless-input border_bottom"
                        style="font-size: 30px"
                        v-model="editModel.orderReceivedAmount"
                        @change="handleItemChangeByTotal"
                        placeholder="0"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="配送成本" prop="freightCost" key="freightCost">
                      <el-input
                        type="number"
                        class="borderless-input"
                        style="font-size: 20px"
                        v-model="editModel.freightCost"
                        @change="handleItemChange"
                        placeholder="0"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </height-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog
      width="280px"
      :show-close="false"
      :append-to-body="true"
      :visible="queryDialogVisible"
      :title="queryErrorMsg ? '提示' : '查询中'"
    >
      <template v-if="queryIng">
        <div>正在查询中</div>
      </template>
      <template v-else-if="queryDialogVisible">
        <span>{{ queryErrorMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="queryDialogVisible = false">
            确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      width="280px"
      :show-close="false"
      :append-to-body="true"
      :visible="submitDialogVisible"
      :title="submitErrorMsg ? '提示' : '创建中'"
    >
      <template v-if="submitIng">
        <div>正在创建中</div>
      </template>
      <template v-else-if="submitDialogVisible">
        <span>{{ submitErrorMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitDialogVisible = false">
            确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.borderless-input {
  & /deep/ .el-input__inner {
    border: none;
    padding-left: 0px;
    background-color: transparent;
  }
  & /deep/ .el-input-group__append {
    border: none;
    padding-left: 0px;
    background-color: transparent;
  }
  & /deep/ .el-input-group__prepend {
    border: none;
    padding-left: 0px;
    background-color: transparent;
  }
}

.border_bottom {
  border-bottom: 1px solid #919191;
}

.config-box {
  .config-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .config-left {
      width: calc(100% - 280px);
      min-height: 200px;
      margin-right: 20px;
      border-right: 1px solid #f1f1f1;
    }

    .config-right {
      width: 260px;
      min-height: 200px;
    }
  }
}
</style>
<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehouseGoodsSelect from "../../../../components/business/warehouseGoodsSelect.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import heightView from "../../../../components/heightView.vue";
import orderPayment from "./__payment.vue";

const defaultModel = {
  freightCost: 0,
  orderReceivedAmount: 0,
  unlockNumber: "",
  consumeName: "匿名",
  consumePhone: "",
};

export default {
  components: {
    customerStoreSelect,
    warehouseGoodsSelect,
    goodsSkuSelect,
    goodsSkuInfo,
    heightView,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editModel: null,
      editRules: {},
      goodsItemList: [],
      formInline: {},
      queryIng: false,
      queryErrorMsg: "",
      queryDialogVisible: false,
      submitIng: false,
      submitErrorMsg: "",
      submitDialogVisible: false,
    };
  },
  computed: {
    storeGuid() {
      return this.pageParams.storeGuid;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
    goodsSelectParams() {
      return {
        minStock: 0.01,
      };
    },
    excludeSkuGuids() {
      if (this.goodsItemList) {
        return this.goodsItemList.map((i) => {
          return i.skuGuid;
        });
      }
      return [];
    },
  },
  methods: {
    clearClick() {
      this.goodsItemList = [];
      this.editModel = Object.assign({}, defaultModel);
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.goodsItemList || []).forEach((item) => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleItemChange() {
      let amount = 0;
      (this.goodsItemList || []).forEach((goods) => {
        amount += Number(goods.goodsCount * goods.goodsPrice);
      });
      this.editModel.orderReceivedAmount = Number(Number(amount).toFixed(2));
    },
    handleItemChangeByTotal() {
      let amount = 0;
      (this.goodsItemList || []).forEach((goods) => {
        amount += Number(goods.goodsCount * goods.goodsPrice);
      });
      if (this.editModel.orderReceivedAmount < 0) {
        this.editModel.orderReceivedAmount = 0;
      }
    },
    handleAddSelectList(list) {
      this.queryIng = true;
      this.queryErrorMsg = null;
      return Promise.resolve(list)
        .then((list) => {
          (list || []).forEach((goodsInfo) => {
            this.handleAddItem({ goodsInfo });
          });
        })
        .catch((err) => {
          this.queryErrorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.queryIng = false;
          this.queryDialogVisible = !!this.queryErrorMsg;
        });
    },
    removeClick(row) {
      if (!this.goodsItemList) {
        this.goodsItemList = [];
      }
      let indexOf = -1;
      this.goodsItemList.forEach((i, index) => {
        if (row.skuInfo && row.skuInfo.guid == i.skuGuid) {
          indexOf = index;
        } else if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.goodsItemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    handleAddItem(resp) {
      // 创建列表备份
      let findItem;
      let tempItemList = this.toAny(JSON.stringify(this.goodsItemList), []);
      tempItemList.forEach((item) => {
        if (item.skuGuid == resp.skuGuid) {
          findItem = item;
        }
      });
      if (!findItem) {
        findItem = {
          skuGuid: resp.goodsInfo.skuGuid,
          skuInfo: resp.goodsInfo.skuInfo,
          goodsInfo: resp.goodsInfo,
          goodsPrice: resp.goodsInfo.retailPrice || 0,
          goodsZsmList: [],
          goodsCount: 0,
          optRemark: "",
        };
        tempItemList.unshift(findItem);
      }
      findItem.goodsCount += 1;
      if (!findItem.goodsCount || findItem.goodsCount <= 0) {
        throw new Error("请输入商品数量，必须大于0");
      }
      if (findItem.goodsInfo.stockCount < findItem.goodsCount) {
        throw new Error("商品【" + findItem.goodsInfo.goodsTitle + "】库存不足");
      }
      this.goodsItemList = tempItemList;
      this.handleItemChange();
    },
    handleScan(value) {
      if (this.queryIng) {
        return;
      }
      this.queryIng = true;
      this.queryErrorMsg = null;
      this.queryDialogVisible = true;
      return this.requestApi("biz.warehouse.goods.info.outboundQuery", {
        queryValue: value,
        storeGuid: this.storeGuid,
      })
        .then((resp) => {
          this.handleAddItem(resp.data);
        })
        .catch((err) => {
          this.queryErrorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.queryIng = false;
          this.queryDialogVisible = !!this.queryErrorMsg;
        });
    },
    submitClick() {
      this.submitIng = true;
      this.submitErrorMsg = null;
      this.submitDialogVisible = true;
      return this.requestApi(
        "biz.warehouse.order.info.create",
        Object.assign(
          {
            orderType: "unmanned",
            orderSerial: "无人仓订单#" + new Date().format("MMddhhmm"),
            itemList: this.goodsItemList.map((item) => {
              return {
                skuGuid: item.skuGuid,
                goodsCount: item.goodsCount,
                goodsPrice: item.goodsPrice,
              };
            }),
          },
          this.editModel || {},
          {
            storeGuid: this.storeGuid,
          }
        )
      )
        .then((resp) => {
          this.success("保存成功");
          this.$drawer.refreshDrawer();
          this.$drawer.backDrawer();
        })
        .catch((err) => {
          this.submitErrorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.submitIng = false;
          this.submitDialogVisible = !!this.submitErrorMsg;
        });
    },
    getDetail() {
      this.clearClick();
      if (this.pageParams.guid) {
        this.loading = true;
        this.errorMsg = null;
        return this.requestApi("biz.warehouse.order.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.order.item.list", {
              orderGuid: resp.data.guid,
              storeGuid: resp.data.storeGuid,
            }).then((listResp) => {
              this.goodsItemList = (listResp.data.list || []).map((item) => {
                return {
                  skuGuid: item.goodsInfo.skuGuid,
                  skuInfo: item.goodsInfo.skuInfo,
                  goodsInfo: item.goodsInfo,
                  goodsPrice: item.goodsPrice || 0,
                  goodsCount: item.goodsCount || 0,
                  optRemark: "",
                };
              });
              this.editModel = Object.assign({}, defaultModel, {
                freightCost: resp.data.freightCost,
                orderReceivedAmount: resp.data.orderReceivedAmount,
              });
              this.handleItemChange();
            });
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.goodsItemList = [];
        this.editModel = Object.assign({}, defaultModel, {
          storeGuid: this.storeGuid,
          freightCost: 0,
          orderReceivedAmount: 0,
        });
      }
    },
  },
  mounted() {
    this.onScan(this.handleScan);
    this.getDetail();
  },
  destroyed() {
    this.offScan(this.handleScan);
  },
};
</script>
